var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7085 3.5H16.4793",
    stroke: "#262626",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 9.75L12.8334 14.4375L8.66675 14.4375",
    stroke: "#262626",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 3.5L12.8335 5.58333",
    stroke: "#262626",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8333,
    cy: 13.9154,
    r: 7.88333,
    stroke: "#262626",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.70ae4bb957d9e87e68b568bd4a8fd9bb.svg";
export { ForwardRef as ReactComponent };